// react
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as Sentry from '@sentry/react';

// router
import { useNavigate } from 'react-router-dom';
import { DYNAMIC_ROUTES, ROUTES } from 'router/routes';

// components
import { AdminBacktestFormPage } from '@karehero/llama/pwa/pages/AdminBacktestFormPage/AdminBacktestFormPage';

// hooks
import { TrackingEvent, useTracking } from 'hooks/useTracking';

// store
import { CreateBacktestRequest } from '@karehero/models';
import {
  useCreateBacktestMutation,
  useListEvaluationSourcesQuery,
} from 'store/api/evaluation';
import { newToast } from 'store/slices/uiSlice';

// utils
import { apiErrorMessage, isInputError } from 'utils/apiErrors';

const SUBMIT_FAILED_MESSAGE = 'The backtest could not be created.';

export const AdminBacktestNew = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { track } = useTracking();
  const { data: sources = [], isLoading: isLoadingSources } =
    useListEvaluationSourcesQuery();
  const [createBacktest, { isLoading }] = useCreateBacktestMutation();
  const [errorMessage, setErrorMessage] = useState<string>();

  const handleSubmit = async (request: CreateBacktestRequest) => {
    setErrorMessage(undefined);
    const result = await createBacktest(request);
    if ('error' in result) {
      if (!isInputError(result.error)) Sentry.captureException(result.error);
      setErrorMessage(apiErrorMessage(result.error, SUBMIT_FAILED_MESSAGE));
      return;
    }
    track(TrackingEvent.BacktestCreated, { transcript: request.transcript });
    dispatch(newToast({ title: 'Backtest created', variant: 'success' }));
    navigate(DYNAMIC_ROUTES.ADMIN_BACKTEST(result.data.id), { replace: true });
  };

  return (
    <AdminBacktestFormPage
      sources={sources}
      isLoading={isLoadingSources}
      onSubmit={handleSubmit}
      onCancel={() =>
        navigate(ROUTES.ADMIN_BACKTESTS, { state: { back: true } })
      }
      isSubmitting={isLoading}
      errorMessage={errorMessage}
    />
  );
};

export default AdminBacktestNew;
